import {
  dark,
  experimental__simple,
  experimental_createTheme,
} from "@clerk/themes";

export const reflagDark = experimental_createTheme({
  baseTheme: dark,
});

export const reflagLight = experimental_createTheme({
  baseTheme: experimental__simple,
});
